//@flow
export const FETCH_LIST_REQUESTED = "tags/FETCH_LIST_REQUESTED";
export const FETCH_LIST_COMPLETED = "tags/FETCH_LIST_COMPLETED";
export const FETCH_LIST_FAILED = "tags/FETCH_LIST_FAILED";

export const RESET_LIST = "tags/RESET_LIST";
